jQuery_T4NT(document).ready(function($) {

$( document ).on( "variant:changed", function( evt ) {

document.querySelector(`.cartFusion_fbt_item select option[value="${evt.currentVariant.id}"]`).selected = true;

const fbtPPS = evt.target.querySelector(`#parentProduct select option[data-variantcon="${evt.currentVariant.title}"]`);
const wrapperHide = document.querySelector('.sr4-fbt__products .sr4-quantity-wrapper');
const fbtSubmitBTN = document.querySelector('.sr4-fbt__submit');
const fbtSubmit = document.querySelector('.sr4-fbt__submit .sr4-btn-atc_text');
// if (fbtPPS) {
//   fbtPPS.selected = true;
//   wrapperHide.style.display = "block";
//   fbtSubmit.innerHTML = 'ADD TO CART';
//   fbtSubmitBTN.disabled = false ;
// } else{
//   wrapperHide.style.display = "none";
//   fbtSubmit.innerHTML = 'Out of Stock';
//   fbtSubmitBTN.disabled = true ;
// } 
})
});